"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = exports.ListObjects = exports.List = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var generic_1 = require("../generic");
var buttons_1 = require("../buttons");
var config_1 = require("../../config");
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    List.prototype.render = function () {
        return React.createElement("ul", { className: "List" }, this.props.children);
    };
    List = __decorate([
        mobx_react_1.observer
    ], List);
    return List;
}(React.Component));
exports.List = List;
var ListObjects = (function (_super) {
    __extends(ListObjects, _super);
    function ListObjects() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderItem = function (obj) {
            var props = _this.props;
            return (React.createElement(ListItem, { editable: props.editable || false, deletable: props.deletable || false, detachable: props.detachable || false, onEditClick: function (e) {
                    if (props.handleEdit)
                        props.handleEdit(obj);
                }, onDeleteClick: function (e) {
                    if (props.handleDelete)
                        props.handleDelete(obj);
                }, onDetachClick: function (e) {
                    if (props.handleDetach)
                        props.handleDetach(obj);
                }, url: props.getUrl ? props.getUrl(obj) : null, key: props.getKey ? props.getKey(obj) : null }, props.getListItemContent(obj)));
        };
        _this.renderList = function (objects) {
            return (React.createElement(List, null, objects.map(function (obj) {
                return _this.renderItem(obj);
            })));
        };
        return _this;
    }
    ListObjects.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var objects = props.objects;
        if (props.sortObjects)
            objects = props.objects.sort(props.sortObjects);
        return (React.createElement(React.Fragment, null, props.groupByFunc ?
            (0, config_1.groupBy)(objects, props.groupByFunc)
                .map(function (group) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: props.groupKeyClassName || "GroupKey" }, group.key),
                    _this.renderList(group.members)));
            })
            :
                this.renderList(objects)));
    };
    ListObjects = __decorate([
        mobx_react_1.observer
    ], ListObjects);
    return ListObjects;
}(React.Component));
exports.ListObjects = ListObjects;
var ListItem = (function (_super) {
    __extends(ListItem, _super);
    function ListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListItem.prototype.render = function () {
        var props = this.props;
        var needsButtons = props.editable || props.deletable || props.detachable;
        var content = (React.createElement("span", { className: "ListItem__Content" }, this.props.children));
        var targetRef = props.targetRef === undefined ? false : props.targetRef;
        var editProps;
        var deleteProps;
        var detachProps;
        if (targetRef) {
            editProps = {
                buttonRef: function (button) {
                    $(button).click(function (e) { return props.onEditClick(e); });
                }
            };
            deleteProps = {
                buttonRef: function (button) {
                    $(button).click(function (e) { return props.onDeleteClick(e); });
                }
            };
            detachProps = {
                buttonRef: function (button) {
                    $(button).click(function (e) { return props.onDetachClick(e); });
                }
            };
        }
        else {
            editProps = {
                onClick: props.onEditClick
            };
            deleteProps = {
                onClick: props.onDeleteClick
            };
            detachProps = {
                onClick: props.onDetachClick
            };
        }
        return React.createElement("li", { className: "ListItem" },
            needsButtons &&
                React.createElement("span", null,
                    props.editable &&
                        React.createElement(buttons_1.InvisibleButton, __assign({}, editProps),
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.edit, fixedWidth: true, floatLeft: true })),
                    props.deletable &&
                        React.createElement(buttons_1.InvisibleButton, __assign({}, deleteProps),
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.delete, fixedWidth: true, floatLeft: true })),
                    props.detachable &&
                        React.createElement(buttons_1.InvisibleButton, __assign({}, detachProps),
                            React.createElement(generic_1.Icon, { name: generic_1.Icons.unlink, fixedWidth: true, floatLeft: true }))),
            props.url ?
                React.createElement(buttons_1.HoverHighlightAnchor, { onClick: function () {
                        window.location.href = props.url;
                    } }, content)
                :
                    React.createElement("span", null, content));
    };
    ListItem = __decorate([
        mobx_react_1.observer
    ], ListItem);
    return ListItem;
}(React.Component));
exports.ListItem = ListItem;
